<mat-toolbar>
    <mat-icon (click)="navigatePrev()" *ngIf="canNavigatePrev" class="pointer">arrow_back</mat-icon>
    <span style="margin-left: 10px;">{{ path || 'Archivos'}}</span>
    <span class="spacer"></span>
    <mat-icon (click)="openNewDocuemnt()" class="pointer icon" [matTooltip]="'Crear Documento'">description</mat-icon>
    <mat-icon (click)="openUploadNewFile()" class="pointer icon" [matTooltip]="'Subir Documento'">upload_file</mat-icon>
    <button mat-icon-button (click)="toggleView()" class="pointer" [matTooltip]="isGridView ? 'Ver como lista' : 'Ver como cuadrícula'">
        <mat-icon>{{isGridView ? 'view_list' : 'grid_view'}}</mat-icon>
    </button>
</mat-toolbar>
<div class="container">
    <div *ngIf="folderTreeNode.children && folderTreeNode.children.length > 0; else noContent">
        <mat-list *ngIf="!isGridView">
            <mat-list-item *ngFor="let element of folderTreeNode.children" class="file-or-folder">
                <div class="list-item-content" (click)="navigateTo(element)">
                    <div class="file-icon-container">
                        <mat-icon color="primary" *ngIf="element.isFolder">folder</mat-icon>
                        <mat-icon *ngIf="!element.isFolder" color="primary">insert_drive_file</mat-icon>
                        <mat-icon *ngIf="!element.isFolder && element.requiresSignature && element.isFullySigned" 
                                class="status-icon signed" 
                                color="primary">task_alt
                        </mat-icon>
                        <mat-icon *ngIf="!element.isFolder && element.signState === 0" 
                                class="status-icon pending" 
                                color="warn">pending_actions
                        </mat-icon>
                        <mat-icon *ngIf="!element.isFolder && element.signState === 2" 
                                class="status-icon rejected" 
                                color="primary">cancel
                        </mat-icon>
                    </div>
                    <span class="list-item-name">{{element.name}}</span>
                </div>
            </mat-list-item>
        </mat-list>
        <mat-grid-list gutterSize="10px" cols="4" rowHeight="100px" *ngIf="isGridView">
            <mat-grid-tile *ngFor="let element of folderTreeNode.children" class="file-or-folder">
                <span [matMenuTriggerFor]="rootMenu" [matMenuTriggerData]="{element: element}"
                #menuTrigger="matMenuTrigger"></span>
                <div (click)="navigateTo(element)" (contextmenu)="openMenu($event,element, menuTrigger)"
                class="grid-element">
                    <mat-icon color="primary" class="file-or-folder-icon pointer" *ngIf="element.isFolder">folder</mat-icon>
                    <div class="file-icon-container" *ngIf="!element.isFolder">
                        <mat-icon class="file-or-folder-icon pointer" color="primary">insert_drive_file</mat-icon>
                        <i class='far fa-file-pdf'></i>
                        <mat-icon *ngIf="element.requiresSignature && element.isFullySigned" 
                            class="status-icon signed" 
                            color="primary">task_alt
                        </mat-icon>
                        <mat-icon *ngIf="element.signState === 0" 
                            class="status-icon pending" 
                            color="warn">pending_actions
                        </mat-icon>
                        <mat-icon *ngIf="element.signState === 2" 
                            class="status-icon rejected" 
                            color="warn">cancel
                        </mat-icon>

                    </div>
                    <!-- <mat-icon *ngIf="!element.isFolder" class="file-or-folder-icon pointer" color="primary">insert_drive_file</mat-icon> -->
                    <span class="grid-title">{{element.name}}</span>
                </div>
            </mat-grid-tile>
        </mat-grid-list>
    </div>
</div>

<mat-menu #rootMenu="matMenu" [overlapTrigger]="false">
    <ng-template matMenuContent let-element="element">
        <button (click)="openPreviewDocument(element)" mat-menu-item>
            <mat-icon>remove_red_eye</mat-icon>
            <span>Visualizar</span>
        </button>
        <a mat-menu-item [href]="element.url">
            <mat-icon>file_download</mat-icon>
            <span>Descargar</span>
        </a>
        <button mat-menu-item (click)="deleteFile(element)">
            <mat-icon>delete</mat-icon>
            <span>Eliminar</span>
        </button>
        <button mat-menu-item (click)="clickCancelFileSign(element)">
            <mat-icon>cancel</mat-icon>
            <span>Cancelar</span>
        </button>
    </ng-template>
</mat-menu>

<ng-template #noContent>
    <h3 style="text-align: center;">{{noContentMessage}}</h3>
</ng-template>